import React from 'react';
import { Redirect, Switch, Route } from 'react-router';
import Routes from 'routes';
import { useRouteGuards } from 'globals/hooks/useRouteGuards';
import FsSnackbarProvider from 'ui-elements/notifications/FsSnackbarProvider';
import UserPanel from 'components/UserPanel';
import Upgrade from 'components/Upgrade';
import Registration from 'components/Registration';

const App: React.FC = () => {
  const isUpgradeRoute = useRouteGuards(Routes.UPGRADE);
  const isUserPanelRoute = useRouteGuards(Routes.ROOT);

  return (
    <FsSnackbarProvider>
      <Switch>
        {isUpgradeRoute && (
          <Route
            exact
            path={Routes.UPGRADE_WITH_PARAMETERS}
            component={Upgrade}
          />
        )}

        {isUserPanelRoute && <Route path={Routes.ROOT} component={UserPanel} />}

        <Route
          path={[
            Routes.REGISTER,
            Routes.LOGIN_WITH_PARAMETERS,
            Routes.REGISTER_FROM_INVITATION_WITH_PARAMETERS,
            Routes.RESET_PASSWORD_WITH_PARAMETERS,
          ]}
          exact
          component={Registration}
        />

        <Redirect to={Routes.LOGIN} />
      </Switch>
    </FsSnackbarProvider>
  );
};

App.displayName = 'App';

export default App;
